var exports = {
  "h": "IconWrapper__yfqcMa",
  "J": "notRounded__0LsE_H",
};

module.exports = exports;
